<div fxLayout="column" fxLayoutAlign="center center" class="w100">
  <div class="spinnerCGO mb-20"></div>
  <a *ngIf="tokenObtenido" [href]="urlKB" target="_blank" id="botonKB" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
    <h2 class="enlace">{{'KNOWLEDGE.LINK' | translate}}</h2>
  </a>
</div>
